// import React, { useState, useEffect } from 'react';
// import { FaTimes, FaPlane, FaExclamationCircle, FaCheckCircle } from 'react-icons/fa';

// const FlightModal = ({ isOpen, onClose, onAdd, editingItem }) => {
//   const [formData, setFormData] = useState({
//     name: '',
//     airline: '',
//     flightNumber: '',
//     departure: '',
//     arrival: '',
//     departureTime: '',
//     arrivalTime: '',
//     price: '',
//     class: 'Economy'
//   });

//   const [errors, setErrors] = useState({});
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const pad = (num) => String(num).padStart(2, '0');
//   const formatDateTimeLocal = (date) => {
//     const d = new Date(date);
//     return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
//   };

//   useEffect(() => {
//     if (editingItem) {
//       setFormData(editingItem);
//     } else {
//       const now = new Date();
//       const defaultDeparture = new Date(now.getTime() + 2 * 60 * 60 * 1000);
//       const defaultArrival = new Date(now.getTime() + 5 * 60 * 60 * 1000);
//       setFormData({
//         name: '',
//         airline: '',
//         flightNumber: '',
//         departure: '',
//         arrival: '',
//         departureTime: formatDateTimeLocal(defaultDeparture),
//         arrivalTime: formatDateTimeLocal(defaultArrival),
//         price: '',
//         class: 'Economy'
//       });
//     }
//     setErrors({});
//   }, [editingItem, isOpen]);

//   const validateForm = () => {
//     const newErrors = {};
    
//     if (!formData.name.trim()) newErrors.name = 'Flight name is required';
//     if (!formData.airline.trim()) newErrors.airline = 'Airline is required';
//     if (!formData.flightNumber.trim()) newErrors.flightNumber = 'Flight number is required';
//     if (!formData.departure.trim()) newErrors.departure = 'Departure city is required';
//     if (!formData.arrival.trim()) newErrors.arrival = 'Arrival city is required';
//     if (!formData.departureTime) newErrors.departureTime = 'Departure time is required';
//     if (!formData.arrivalTime) newErrors.arrivalTime = 'Arrival time is required';
//     if (!formData.price.trim()) newErrors.price = 'Price is required';
    
//     // Validate departure time is before arrival time
//     if (formData.departureTime && formData.arrivalTime) {
//       const depTime = new Date(formData.departureTime);
//       const arrTime = new Date(formData.arrivalTime);
//       if (depTime >= arrTime) {
//         newErrors.arrivalTime = 'Arrival time must be after departure time';
//       }
//     }
    
//     // Validate price format
//     if (formData.price && !/^\$?\d+(\.\d{2})?$/.test(formData.price)) {
//       newErrors.price = 'Please enter a valid price (e.g., $299 or 299)';
//     }
    
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     if (!validateForm()) {
//       return;
//     }
    
//     setIsSubmitting(true);
    
//     try {
//       // Simulate API call delay
//       await new Promise(resolve => setTimeout(resolve, 500));
      
//       onAdd(formData);
//       onClose();
//     } catch (error) {
//       console.error('Error submitting flight:', error);
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const handleInputChange = (field, value) => {
//     setFormData(prev => ({ ...prev, [field]: value }));
//     // Clear error when user starts typing
//     if (errors[field]) {
//       setErrors(prev => ({ ...prev, [field]: '' }));
//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 z-50 !m-0 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-md p-4 animate-fadeIn">
//       <div className="bg-white rounded-2xl shadow-2xl max-w-5xl w-full max-h-[90vh] flex flex-col transform transition-all duration-300 scale-100">
//         {/* Enhanced Header */}
//         <div className="bg-gradient-to-r from-blue-600 via-blue-700 to-indigo-700 p-8 rounded-t-2xl relative overflow-hidden">
//           <div className="absolute inset-0 bg-black bg-opacity-10"></div>
//           <div className="relative flex items-center justify-between">
//             <div className="flex items-center space-x-4">
//               <div className="bg-white bg-opacity-20 p-3 rounded-xl backdrop-blur-sm border border-white border-opacity-30">
//                 <FaPlane className="h-7 w-7 text-white" />
//               </div>
//               <div>
//                 <h3 className="text-2xl font-display font-bold text-white">
//                   {editingItem ? 'Edit Flight Reservation' : 'Add New Flight'}
//                 </h3>
//                 <p className="text-blue-100 text-lg">Complete flight booking details</p>
//               </div>
//             </div>
//             <button
//               onClick={onClose}
//               className="text-white hover:bg-white hover:bg-opacity-20 p-3 rounded-xl transition-all duration-200 hover:scale-105"
//             >
//               <FaTimes className="h-6 w-6" />
//             </button>
//           </div>
//         </div>

//         <div className="flex-1 overflow-y-auto bg-gray-50">
//           <form id="flight-form" onSubmit={handleSubmit} className="p-8 space-y-8">
            
//             {/* Route Information Section */}
//             <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
//               <h4 className="text-lg font-semibold text-gray-900 mb-6 flex items-center">
//                 <div className="w-2 h-2 bg-green-500 rounded-full mr-3"></div>
//                 Route Information
//               </h4>
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                 <div>
//                   <label className="block text-sm font-semibold text-gray-700 mb-3">
//                     Departure City *
//                   </label>
//                   <div className="relative">
//                     <input
//                       type="text"
//                       value={formData.departure}
//                       onChange={(e) => handleInputChange('departure', e.target.value)}
//                       className={`w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all duration-200 ${
//                         errors.departure ? 'border-red-300 bg-red-50' : 'border-gray-300 hover:border-gray-400'
//                       }`}
//                       placeholder="e.g., New York (JFK)"
//                     />
//                     {errors.departure && (
//                       <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
//                         <FaExclamationCircle className="h-5 w-5 text-red-500" />
//                       </div>
//                     )}
//                   </div>
//                   {errors.departure && (
//                     <p className="mt-2 text-sm text-red-600 flex items-center">
//                       <FaExclamationCircle className="h-4 w-4 mr-1" />
//                       {errors.departure}
//                     </p>
//                   )}
//                 </div>

//                 <div>
//                   <label className="block text-sm font-semibold text-gray-700 mb-3">
//                     Arrival City *
//                   </label>
//                   <div className="relative">
//                     <input
//                       type="text"
//                       value={formData.arrival}
//                       onChange={(e) => handleInputChange('arrival', e.target.value)}
//                       className={`w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all duration-200 ${
//                         errors.arrival ? 'border-red-300 bg-red-50' : 'border-gray-300 hover:border-gray-400'
//                       }`}
//                       placeholder="e.g., Los Angeles (LAX)"
//                     />
//                     {errors.arrival && (
//                       <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
//                         <FaExclamationCircle className="h-5 w-5 text-red-500" />
//                       </div>
//                     )}
//                   </div>
//                   {errors.arrival && (
//                     <p className="mt-2 text-sm text-red-600 flex items-center">
//                       <FaExclamationCircle className="h-4 w-4 mr-1" />
//                       {errors.arrival}
//                     </p>
//                   )}
//                 </div>

//                 <div>
//                   <label className="block text-sm font-semibold text-gray-700 mb-3">
//                     Departure Time *
//                   </label>
//                   <div className="relative">
//                     <input
//                       type="datetime-local"
//                       value={formData.departureTime}
//                       onChange={(e) => handleInputChange('departureTime', e.target.value)}
//                       className={`w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all duration-200 ${
//                         errors.departureTime ? 'border-red-300 bg-red-50' : 'border-gray-300 hover:border-gray-400'
//                       }`}
//                     />
//                     {errors.departureTime && (
//                       <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
//                         <FaExclamationCircle className="h-5 w-5 text-red-500" />
//                       </div>
//                     )}
//                   </div>
//                   {errors.departureTime && (
//                     <p className="mt-2 text-sm text-red-600 flex items-center">
//                       <FaExclamationCircle className="h-4 w-4 mr-1" />
//                       {errors.departureTime}
//                     </p>
//                   )}
//                 </div>

//                 <div>
//                   <label className="block text-sm font-semibold text-gray-700 mb-3">
//                     Arrival Time *
//                   </label>
//                   <div className="relative">
//                     <input
//                       type="datetime-local"
//                       value={formData.arrivalTime}
//                       onChange={(e) => handleInputChange('arrivalTime', e.target.value)}
//                       className={`w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all duration-200 ${
//                         errors.arrivalTime ? 'border-red-300 bg-red-50' : 'border-gray-300 hover:border-gray-400'
//                       }`}
//                     />
//                     {errors.arrivalTime && (
//                       <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
//                         <FaExclamationCircle className="h-5 w-5 text-red-500" />
//                       </div>
//                     )}
//                   </div>
//                   {errors.arrivalTime && (
//                     <p className="mt-2 text-sm text-red-600 flex items-center">
//                       <FaExclamationCircle className="h-4 w-4 mr-1" />
//                       {errors.arrivalTime}
//                     </p>
//                   )}
//                 </div>
//               </div>
//             </div>

//             {/* Pricing Section */}
          
//           </form>
//         </div>
//         {/* Enhanced Footer */}
//         <div className="flex-shrink-0 bg-white border-t border-gray-200 p-8">
//           <div className="flex flex-col sm:flex-row gap-4">
//             <button
//               type="submit"
//               form="flight-form"
//               disabled={isSubmitting}
//               className="flex-1 bg-gradient-to-r from-blue-600 via-blue-700 to-indigo-700 text-white py-4 px-8 rounded-xl font-semibold text-lg hover:from-blue-700 hover:via-blue-800 hover:to-indigo-800 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none disabled:shadow-lg flex items-center justify-center space-x-2"
//             >
//               {isSubmitting ? (
//                 <>
//                   <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
//                   <span>Processing...</span>
//                 </>
//               ) : (
//                 <>
//                   <FaCheckCircle className="h-5 w-5" />
//                   <span>{editingItem ? 'Update Flight Reservation' : 'Add Flight to Booking'}</span>
//                 </>
//               )}
//             </button>
//             <button
//               onClick={onClose}
//               disabled={isSubmitting}
//               className="flex-1 bg-gray-100 text-gray-700 py-4 px-8 rounded-xl font-semibold text-lg hover:bg-gray-200 transition-all duration-300 border border-gray-300 hover:border-gray-400 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center space-x-2"
//             >
//               <FaTimes className="h-5 w-5" />
//               <span>Cancel</span>
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default FlightModal;import React, { useState, useEffect } from "react";
import { useEffect, useState } from "react";
import {
  FaTimes,
  FaPlane,
  FaExclamationCircle,
  FaCheckCircle,
} from "react-icons/fa";

const dummyFlights = [
  { id: 1, name: "Air India 101", price: "₹4500" },
  { id: 2, name: "IndiGo 302", price: "₹5200" },
  { id: 3, name: "Vistara 220", price: "₹6100" },
  { id: 4, name: "SpiceJet 440", price: "₹3900" },
];

const FlightModal = ({ isOpen, onClose, onAdd, editingItem }) => {
  const [formData, setFormData] = useState({
    departure: "",
    arrival: "",
    departureTime: "",
    arrivalTime: "",
  });
  const [errors, setErrors] = useState({});
  const [showResults, setShowResults] = useState(false);

  useEffect(() => {
  if (editingItem) {
    setFormData(editingItem);
  } else {
    // prefill default dates
    const now = new Date();
    const twoHoursLater = new Date(now.getTime() + 2 * 60 * 60 * 1000);

    setFormData({
      departure: "",
      arrival: "",
      departureTime: now.toISOString().slice(0, 16), // format for datetime-local
      arrivalTime: twoHoursLater.toISOString().slice(0, 16),
    });
  }
  setErrors({});
  setShowResults(false);
}, [editingItem, isOpen]);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.departure.trim())
      newErrors.departure = "Departure city is required";
    if (!formData.arrival.trim())
      newErrors.arrival = "Arrival city is required";
    if (!formData.departureTime)
      newErrors.departureTime = "Departure time is required";
    if (!formData.arrivalTime)
      newErrors.arrivalTime = "Arrival time is required";

    // time validation
    if (formData.departureTime && formData.arrivalTime) {
      const dep = new Date(formData.departureTime);
      const arr = new Date(formData.arrivalTime);
      if (dep >= arr) {
        newErrors.arrivalTime = "Arrival must be after departure";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setShowResults(true);
  };

  const handleSelectFlight = (flight) => {
    const selectedFlight = {
      ...formData,
      name: flight.name,
      price: flight.price,
    };
    onAdd(selectedFlight);
    onClose();
  };

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-md p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] flex flex-col">
        {/* Header */}
        <div className="bg-gradient-to-r from-blue-600 to-indigo-700 p-6 rounded-t-2xl flex justify-between items-center">
          <div className="flex items-center space-x-3">
            <FaPlane className="text-white text-2xl" />
            <h3 className="text-xl font-bold text-white">
              {editingItem ? "Edit Flight" : "Add Flight"}
            </h3>
          </div>
          <button
            onClick={onClose}
            className="text-white hover:bg-white hover:bg-opacity-20 p-2 rounded-xl"
          >
            <FaTimes className="h-5 w-5" />
          </button>
        </div>

        {/* Body */}
        <div className="flex-1 overflow-y-auto p-6 space-y-6 bg-gray-50">
          {!showResults ? (
            <form onSubmit={handleSearch} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Departure */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Departure City *
                  </label>
                  <input
                    type="text"
                    value={formData.departure}
                    onChange={(e) =>
                      handleInputChange("departure", e.target.value)
                    }
                    className={`w-full px-4 py-3 border rounded-xl ${
                      errors.departure
                        ? "border-red-300 bg-red-50"
                        : "border-gray-300"
                    }`}
                    placeholder="e.g., New York"
                  />
                  {errors.departure && (
                    <p className="text-sm text-red-600 mt-1">
                      {errors.departure}
                    </p>
                  )}
                </div>

                {/* Arrival */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Arrival City *
                  </label>
                  <input
                    type="text"
                    value={formData.arrival}
                    onChange={(e) => handleInputChange("arrival", e.target.value)}
                    className={`w-full px-4 py-3 border rounded-xl ${
                      errors.arrival
                        ? "border-red-300 bg-red-50"
                        : "border-gray-300"
                    }`}
                    placeholder="e.g., Los Angeles"
                  />
                  {errors.arrival && (
                    <p className="text-sm text-red-600 mt-1">
                      {errors.arrival}
                    </p>
                  )}
                </div>

                {/* Departure Time */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Departure Time *
                  </label>
                  <input
                    type="datetime-local"
                    value={formData.departureTime}
                    onChange={(e) =>
                      handleInputChange("departureTime", e.target.value)
                    }
                    className={`w-full px-4 py-3 border rounded-xl ${
                      errors.departureTime
                        ? "border-red-300 bg-red-50"
                        : "border-gray-300"
                    }`}
                  />
                  {errors.departureTime && (
                    <p className="text-sm text-red-600 mt-1">
                      {errors.departureTime}
                    </p>
                  )}
                </div>

                {/* Arrival Time */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Arrival Time *
                  </label>
                  <input
                    type="datetime-local"
                    value={formData.arrivalTime}
                    onChange={(e) =>
                      handleInputChange("arrivalTime", e.target.value)
                    }
                    className={`w-full px-4 py-3 border rounded-xl ${
                      errors.arrivalTime
                        ? "border-red-300 bg-red-50"
                        : "border-gray-300"
                    }`}
                  />
                  {errors.arrivalTime && (
                    <p className="text-sm text-red-600 mt-1">
                      {errors.arrivalTime}
                    </p>
                  )}
                </div>
              </div>

              <div className="flex justify-end">
                <button
                  type="submit"
                  className="bg-blue-600 text-white px-6 py-3 rounded-xl font-semibold hover:bg-blue-700 transition"
                >
                  Search Flights
                </button>
              </div>
            </form>
          ) : (
            <div>
              <h4 className="text-lg font-semibold mb-4">
                Available Flights ✈️
              </h4>
              <div className="space-y-4">
                {dummyFlights.map((flight) => (
                  <div
                    key={flight.id}
                    className="flex justify-between items-center bg-white p-4 rounded-xl shadow"
                  >
                    <div>
                      <p className="font-semibold text-gray-800">
                        {flight.name}
                      </p>
                      <p className="text-gray-500">{flight.price}</p>
                    </div>
                    <button
                      onClick={() => handleSelectFlight(flight)}
                      className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition"
                    >
                      Select
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="bg-white border-t p-4 flex justify-end">
          <button
            onClick={onClose}
            className="bg-gray-100 px-6 py-2 rounded-lg hover:bg-gray-200"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default FlightModal;
